// ReingresoSeriePage.tsx

import { PermissionsEnum } from "@/auth/interfaces";
import { hasPermission, sizeTab, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { TableReingresoSerie } from "../../components";
import ModalKardexSeries from "@/erp/inventario/kardex/componente/ModalKardexSeries";
import { ReingresoSerieChoice } from "../../utils/reingreso-serie.choice";

export default function ReingresoSeriePage() {

  hasPermission(PermissionsEnum.api_view_reingresoserie)

  const [valueTab, setValueTab] = useState(0);

  return (
    <>
      <SingleTableBoxScene title={"Reingreso Serie"}
        py={2}
        visibleReport={true}
      >
        <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 3 }} >
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs reingresoserie"
          >
            <Tab label={'Pendiente'} {...a11yProps(0)} />
            <Tab label={'Aprobadas'} {...a11yProps(1)} />
            <Tab label={'Rechazadas'} {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={valueTab} index={0}>
          <TableReingresoSerie
            estado={ReingresoSerieChoice.EN_ESPERA}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={1}>
          <TableReingresoSerie
            estado={ReingresoSerieChoice.APROBADO}
          />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <TableReingresoSerie
            estado={ReingresoSerieChoice.RECHAZADO}
          />
        </CustomTabPanel>
      </SingleTableBoxScene >

      <ModalKardexSeries />
    </>

  )
}